import { render, staticRenderFns } from "./WarehouseItemLoader.vue?vue&type=template&id=5dc4d30e"
import script from "./WarehouseItemLoader.vue?vue&type=script&lang=js"
export * from "./WarehouseItemLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports